import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const MissingData = styled.div`
    height: 35px;
    width: 100%;
    display: flex;
    align-items: center;
    ${({ isError }) =>
        isError
            ? css`
                  background: #e64a49;
              `
            : css`
                  background: #fed700;
              `}
`;
